import MainPersonalSpace from "../../components/personal-space/main-personal-space";

export default function PersonalSpacePage() {
  return <MainPersonalSpace />;
}
